export function listaUnidadesFederativas() {
  return [
    { label: "AC - Acre", value: "AC" },
    { label: "AL - Alagoas", value: "AL" },
    { label: "AP - Amapá", value: "AP" },
    { label: "AM - Amazonas", value: "AM" },
    { label: "BA - Bahia", value: "BA" },
    { label: "CE - Ceará", value: "CE" },
    { label: "DF - Distrito Federal", value: "DF" },
    { label: "ES - Espírito Santo", value: "ES" },
    { label: "GO - Goiás", value: "GO" },
    { label: "MA - Maranhão", value: "MA" },
    { label: "MT - Mato Grosso", value: "MT" },
    { label: "MS - Mato Grosso do Sul", value: "MS" },
    { label: "MG - Minas Gerais", value: "MG" },
    { label: "PA - Pará", value: "PA" },
    { label: "PB - Paraíba", value: "PB" },
    { label: "PR - Paraná", value: "PR" },
    { label: "PE - Pernambuco", value: "PE" },
    { label: "PI - Piauí", value: "PI" },
    { label: "RJ - Rio de Janeiro", value: "RJ" },
    { label: "RN - Rio Grande do Norte", value: "RN" },
    { label: "RS - Rio Grande do Sul", value: "RS" },
    { label: "RO - Rondônia", value: "RO" },
    { label: "RR - Roraima", value: "RR" },
    { label: "SC - Santa Catarina", value: "SC" },
    { label: "SP - São Paulo", value: "SP" },
    { label: "SE - Sergipe", value: "SE" },
    { label: "TO - Tocantins", value: "TO" }
  ];
}

export function listaBool() {
  return [
    { label: 'Sim', value: true },
    { label: 'Não', value: false }
  ];
}
